import React from "react";
import { useSearchParams } from "react-router-dom";
import "../styles/PaymentComplete.css";

const PaymentComplete = () => {
  const [params] = useSearchParams();
  const txid = params.get("txid"); // read ?txid=... from the URL

  return (
    <div className="payment-container">
      <div className="payment-card">
        <div className="payment-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="white"
            strokeWidth={3}
            className="payment-check"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="payment-title">Payment Successful!</h1>
        <p className="payment-message">
          Thank you. Your transaction has been processed successfully.
        </p>
        <p className="payment-id">
          Transaction ID: <strong>#{txid || "—"}</strong>
        </p>
        <a href="/" className="payment-button">
          Your Matters
        </a>
      </div>
    </div>
  );
};

export default PaymentComplete;
